<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a href="/">Inicio</a></li>
        <li><span class="link-effect">Cambiar contraseña</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Cambiar Contraseña</h3>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
            <label class="col-md-2 control-label">Contraseña actual (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>Ingresa tu contraseña actual</mat-label>
                <input matInput [type]="hideContrasenaActual ? 'password' : 'text'" [(ngModel)]="model.oldPassword" required/>
                <button
                  mat-icon-button
                  matSuffix                  
                  (click)="hideContrasenaActual = !hideContrasenaActual"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideContrasenaActual"
                >
                  <mat-icon>{{ hideContrasenaActual ? "visibility_off" : "visibility" }}</mat-icon>
                </button>
              </mat-form-field>
            </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Nueva contraseña (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>Ingresa tu nueva contraseña</mat-label>
              <input matInput [type]="hideNuevaContrasena ? 'password' : 'text'" [(ngModel)]="model.newPassword" required/>
              <button
                mat-icon-button
                matSuffix                
                (click)="hideNuevaContrasena = !hideNuevaContrasena"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideNuevaContrasena"
              >
                <mat-icon>{{ hideNuevaContrasena ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Confirmar contraseña (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>Confirma tu nueva contraseña</mat-label>
              <input matInput [type]="hideConfirmarContrasena ? 'password' : 'text'" required/>
              <button
                mat-icon-button
                matSuffix
                (click)="hideConfirmarContrasena = !hideConfirmarContrasena"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirmarContrasena"
              >
                <mat-icon>{{ hideConfirmarContrasena ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>



        <div class="form-group">
            <div class="col-sm-12">
              <a class="btn btn-naranja" (click)="submit()" mat-raised-button>Guardar</a>                  
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

  
  <!--[attr.aria-pressed]="hide" linea 36
      [attr.aria-pressed]="hide" linea 23
  -->